<ng-container *ngTemplateOutlet="template"></ng-container>
<ng-template #languageChooserLink>
  <yat-dropdown-link [ngClass]="classNames" *ngIf="availableLangs.length > 1" [placement]="placement">
    <ng-container ngProjectAs="button">
      <yat-icon id="bc7c629b-161f-4887-99b5-39f69a878a98" name="translate-duo" class="mr-[2px]"></yat-icon>
      <span>{{ activeLangLabel$ | async }}</span>
      <yat-icon id="42375a6f-be64-4c32-a711-5c1784870a7c" name="chevron-down"></yat-icon>
    </ng-container>
    <ng-container ngProjectAs="menu">
      <ng-container *ngFor="let lang of availableLangs">
        <div
          yat-link
          class="dropdown-item item"
          yatTabSelectable
          (tabSelect)="setLang(lang.id)"
          [class.selected]="lang.id === (activeLang$ | async)"
          [matomoClickCategory]="MATOMO_EVENT_CATEGORY_LANGUAGE"
          matomoClickAction="Modify_LocalePicker"
          [matomoClickName]="lang.label">
          <div>{{ lang.label }}</div>
          <yat-icon id="e3e26e59-781e-4c2d-ae0c-f6e82c76e81e" name="tick" [class.hidden]="lang.id !== (activeLang$ | async)"></yat-icon>
        </div>
      </ng-container>
    </ng-container>
  </yat-dropdown-link>
</ng-template>
<ng-template #languageChooserMobile>
  <a
    yat-link
    class="link link-secondary dropdown"
    [class.open]="showLanguageSelector"
    yatTabSelectable
    (tabSelect)="toggleLanguageSelector()"
    *ngIf="availableLangs.length > 1">
    <div>
      <yat-icon id="fee3d7ad-2db5-4c5a-a5c0-cc5cf6877c97" name="translate-duo"></yat-icon>
      <span>{{ activeLangLabel$ | async }}</span>
    </div>
    <yat-icon id="f9af943f-157b-4b58-b7e2-10ec387fcc92" name="chevron-down"></yat-icon>
  </a>
  <div class="dropdown-content" *ngIf="showLanguageSelector">
    <ng-container *ngFor="let lang of availableLangs; index as i">
      <a
        yat-link
        class="link link-secondary"
        yatTabSelectable
        (tabSelect)="setLang(lang.id)"
        [class.selected]="lang.id === (activeLang$ | async)"
        [matomoClickCategory]="MATOMO_EVENT_CATEGORY_LANGUAGE"
        matomoClickAction="ChangeLanguageTo"
        [matomoClickName]="lang.label">
        <span>{{ lang.label }}</span>
        <yat-icon id="367752cf-b276-4c73-b4c8-3a9807bfa7b0" class="hidden mr-0" name="tick"></yat-icon>
      </a>
    </ng-container>
  </div>
</ng-template>
